export default __webpack_public_path__ + "static/media/chrome.c17dce48.svg";